export enum JobNodeState {
    Queued = 'Queued',
    Running = 'Running',
    Succeeded = 'Succeeded',
    Failed = 'Failed',
    Canceled = 'Canceled',
    Removed = 'Removed'
}

export interface JobNode {
    name: string;
    state?: JobNodeState;
    result?: any;
}
